export const GetTime = {
    data() {
        return{
            currentTime: '',
            hourNumber: 0,
            minuteNumber: 0,
            secondNumber: 0,
            millisecondNumber: 0,

        }
    },
    computed: {

    },
    created() {
    },
    mounted() {
        this.getNow();
    },
    methods: {
        getNow() {
            this.currentTime = this.$moment(Date.now()).format('yyyy-MM-DD HH:mm:ss.SSSZZ');
            this.v = setInterval(() =>{
                this.currentTime = this.$moment(Date.now()).format('yyyy-MM-DD HH:mm:ss.SSSZZ');
                this.hourNumber=Number.parseInt(this.$moment(this.currentTime).format('hh'));
                this.minuteNumber=Number.parseInt(this.$moment(this.currentTime).format('mm'));
                this.secondNumber=Number.parseInt(this.$moment(this.currentTime).format('ss'));
                this.millisecondNumber=Number.parseInt(this.$moment(this.currentTime).format('SSS'));
            },1)
        },
    },
    filters:{
        clipIp(ip) {
            return ip.replace(/\(.*\)/,'')
        },
    }
}
